export default "__VITE_ASSET__cUbPoA5T__"